import { render, staticRenderFns } from "./DateIntervalField.vue?vue&type=template&id=1a9d8791&"
import script from "./DateIntervalField.vue?vue&type=script&lang=js&"
export * from "./DateIntervalField.vue?vue&type=script&lang=js&"
import style0 from "./DateIntervalField.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QField,QIcon,QTooltip} from 'quasar'
component.options.components = Object.assign({QField,QIcon,QTooltip}, component.options.components || {})
